export default function request (options) {
  options = {
    dataType: 'json',
    method: 'GET',
    params: {},
    ...options
  }
  const xhr = new XMLHttpRequest()
  const defaultResponseTransform = res => res
  const responseTransform = {
    json: res => JSON.parse(res)
  }[options.dataType] || defaultResponseTransform
  const promise = new Promise((resolve, reject) => {
    xhr.onreadystatechange = () => {
      if (xhr.readyState === XMLHttpRequest.DONE) {
        if (xhr.status === 200) {
          resolve(responseTransform(xhr.response))
        } else {
          reject()
        }
      }
    }
  })
  const querystring = Object.keys(options.params).map(key => `${key}=${options.params[key]}`).join('&')
  xhr.open(options.method, options.url + '?' + querystring)
  xhr.setRequestHeader('x-version', '1.0')
  xhr.setRequestHeader('x-app-id', 'wO2Bc0bvfYPNyTSc')
  xhr.withCredentials = true
  xhr.send(options.data)
  return promise
}
